import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from '../libs/contextLib';
import AccountLayout from '../components/user/AccountLayout';
import OrdersList from '../components/user/OrdersList';

export default function AccountHome() {
  const history = useHistory();
  const { handleLogout, getSession } = useAppContext();
  const [session, setSession] = useState(false);
  const [user, setUser] = useState(false);  

  useEffect(() => {

    async function onLoad() {
        try {                       
            const sess = await getSession()
            setSession(sess)
            setUser(sess.user)

        } catch (e) {
            // onError(e);
        } finally {
            // setIsLoading(false)
        }
    }

    onLoad();
  }, []);

  function handleNav(option) {
    if (option === 'orders') {
      // Already here
    } else if (option === 'profile') {
      history.push('/account/profile');
    } else if (option === 'logout') {
      handleLogout();
    }
  }

  return (
    <AccountLayout user={user} selected="orders" onNav={handleNav}>
      <OrdersList user={user} />
    </AccountLayout>
  );
} 